module.exports = __webpack_public_path__ + "static/trail.3f84c4fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/trail/trail.png
// module id = 94
// module chunks = 88197199937824 213720915766396 231729057096947